import React from 'react'
import Icon from 'react-icons-kit'
import { upload, closeCircled } from 'react-icons-kit/ionicons'
import { connect } from 'react-redux'
import { compose } from 'redux'

import ImageListItemForm from './ImageListItemForm'
import Button from '../../views/buttons/Button'
import { withModal } from '../../../modules/modal/withModal'
import ImageListImageEditModal from './ImageListImageEditModal'
import { withImageListItem } from '../image-edit/ImageItem'
import { removeImageListItem } from '../../../actions/portal'
import withPortalId from '../../../modules/portal/withPortalId'
import withRemoveImage from '../image-edit/withRemoveImage'

class ImageListItem extends React.Component {
  render() {
    const { item, itemIndex } = this.props
    return <ImageListItemForm galleryImage={item} index={itemIndex} />
  }
}

let RemoveItemButton = ({ onRemoveImage }) => (
  <Button className="is-white" onClick={onRemoveImage}>
    <Icon icon={closeCircled} size={18} />
  </Button>
)

RemoveItemButton = compose(
  connect(null, (dispatch, { itemIndex: index }) => ({
    onRemoveImageListItem: () => dispatch(removeImageListItem(index)),
  })),
  withRemoveImage(props => ({
    imageId: props.item.mainImageId,
    onRemoveItem: props.onRemoveImageListItem,
  })),
)(RemoveItemButton)

let UploadImageButton = ({ showModal }) => (
  <Button className="is-white" onClick={showModal}>
    <Icon icon={upload} size={24} />
  </Button>
)

UploadImageButton = compose(
  withPortalId,
  withModal(ImageListImageEditModal, {
    props: ownProps => ({
      portalId: ownProps.portalId,
      currentImageId: ownProps.item.mainImageId,
      onReloadImage: ownProps.onReloadImage,
      imageAspectRatio: 4/3,
      longerWidth: 1600
    }),
  }),
)(UploadImageButton)

export default withImageListItem(ImageListItem, [
  UploadImageButton,
  RemoveItemButton,
])



// WEBPACK FOOTER //
// ./src/components/templates/image-list/ImageListItem.js